module.exports = __webpack_public_path__ + "static/media/tKaine.e9c485b2.jpeg";